import { render, staticRenderFns } from "./ClientRouteHistory.vue?vue&type=template&id=3b304a5a&scoped=true"
import script from "./ClientRouteHistory.vue?vue&type=script&lang=js"
export * from "./ClientRouteHistory.vue?vue&type=script&lang=js"
import style0 from "./ClientRouteHistory.vue?vue&type=style&index=0&id=3b304a5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b304a5a",
  null
  
)

export default component.exports